import AOS from 'aos';
import 'aos/dist/aos.css';

export const initAOS = () => {
  AOS.init({
    duration: 2000,
    once: false, // false = l'animazione si ripete quando l'elemento torna in vista
    mirror: true, // true = l'animazione può essere riprodotta al contrario quando si scorre verso l'alto
    offset: 120, // offset (in px) dal punto di trigger originale
    disable: 'mobile' // disabilita le animazioni sui dispositivi mobili per migliorare le prestazioni
  });

  // Aggiorna AOS durante lo scroll
  window.addEventListener('scroll', () => {
    AOS.refresh();
  });
};

// Funzione per aggiornare manualmente AOS
export const refreshAOS = () => {
  AOS.refresh();
}; 